export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";